import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import {
  BillState,
  getBillStateLabel,
  getBillStateVariant,
} from 'src/app/_types/billing.types';
import {
  InlineBadgeComponent,
  InlineBadgeVariant,
} from 'src/app/shared/components/inline-badge/inline-badge.component';

@Component({
  selector: 'app-bill-status-badge',
  standalone: true,
  imports: [InlineBadgeComponent],
  template: `<app-inline-badge
    [badgeContent]="label()"
    [variant]="variant()"
  />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BillStatusBadgeComponent {
  readonly status = input.required<BillState>();

  readonly label = computed(() => getBillStateLabel(this.status()));

  readonly variant = computed<InlineBadgeVariant>(() =>
    getBillStateVariant(this.status())
  );
}
